import { iFrameQueryParams } from '../consts/consts';

export const getIframeUrl = (invoiceId: string | undefined) => {
  const baseUrl = new URL(iFrameQueryParams.BASE_URL);
  baseUrl.searchParams.set(iFrameQueryParams.INVOICE_ID, invoiceId || '');
  baseUrl.searchParams.set(iFrameQueryParams.CREATION_PROCESS, 'true');
  baseUrl.searchParams.set(iFrameQueryParams.ORIGIN, 'webApp');
  return baseUrl.href;
};
